import { OnInit, Component } from '@angular/core'
import { FormGroup, FormControl } from '@angular/forms'
import { Title } from '@angular/platform-browser'

import { Observable, of, empty, zip } from 'rxjs'

import { HybridService } from 'app/shared/hybrid/hybrid.service'
import { SbEvent } from 'app/shared/sb-event.emitter'

import { QuoteChanged, QuoteLine, PriceSpecificationType, UserQuoteDetails, QuoteDeposit } from 'app/shared/quote/quote.events'
import { Country } from 'app/passengers/passengers.models'
import { IInputTermsAndCondition } from 'app/passengers/terms-and-conditions/terms-and-conditions.component'
import { IInputPassengers } from 'app/passengers/passengers/passengers.component'
import { IInputEditUser, IUserDetails, IEditDetaisChangedEvent } from 'app/passengers/edit-user-details/edit-user-details.component'
import { IInputAdditionalPayments, IAdditionalPayments } from 'app/passengers/additional-payments/additional-payments.component'
import { IFlowReservation, SelectionTypeEnum, IFlowReservationPassengers, LocalStorageStepData } from 'app/shared/steps/step.model'
import { ResourceService } from 'app/shared/resources/resource.service'
import { StepService } from 'app/shared/steps/step.service'
import { PassengerService, IAgentInfo } from 'app/passengers/passenger.service'
import { QuoteService } from 'app/shared/quote/quote.service'
import { IInputLoyaltyCard } from 'app/passengers/loyalty/nectar/nectar.component';
import { ILoyaltyCard, IPassenger, LoyaltyActionEnum } from 'app/shared/models/reservation.interfaces'
import { IFlowPassengersAgentWire, IFlowPassengersUserWire } from 'app/passengers/passengers.interfaces'
import { IInputAgentDetails } from 'app/passengers/agent-details/agent-details.component'
import { IInputCreditCard } from 'app/payment/credit-cards/credit-cards.component'
import { IInputVehicleDetailsRows } from 'app/vehicles/vehicles-details-rows/vehicles-details-rows.component'
import { IInputVehicleDetailsRow } from 'app/vehicles/vehicles-details-row/vehicles-details-row.component'
import { IVehicleSelection } from 'app/vehicles/vehicles.interfaces'
import { LayoutState } from 'app/shared/layout/layout-state'
import { EnvironmentService } from 'app/environment.service'
import { Router } from '@angular/router'
import { TrackingService } from 'app/shared/tracking/tracking.service'
import { TrackingFlowStep, ITracking, IWireProduct } from 'app/shared/tracking/tracking-wire.interfaces'
import { PriceChangedPopupModel } from '../price-changed-popup/price-changed-popup.component';
import { IWireFeatureTrack } from 'app/shared/tracking/feature-tracking/feature-tracking.interfaces';
import { StorageService } from 'app/shared/storage.service';

@Component({
    selector: 'sbw-flow-passengers',
    templateUrl: './flow-passengers.component.html',
    styleUrls: ['./flow-passengers.component.css']
})
export class FlowPassengersComponent implements OnInit {

    priceChangedPopupModel: PriceChangedPopupModel
    inputPassengers: IInputPassengers
    inputTermsAndCondition: IInputTermsAndCondition
    inputAgentDetails: IInputAgentDetails
    inputAdditionalPayments: IInputAdditionalPayments
    inputLoyaltyCard: IInputLoyaltyCard
    inputEditUser: IInputEditUser
    inputCreditCard: IInputCreditCard
    inputVehicleDetailsRows: IInputVehicleDetailsRows
    selectedVehicleControl: FormControl
    selectedTrailerControl: FormControl
    editModel: IEditDetaisChangedEvent

    reservation: IFlowReservation
    passengerForm: FormGroup
    errorList: string[]
    specialInstructionsSelected = false
    showSpecialInstructions = false
    hasInvalidUserDetails = false
    loggedInUserType: ELoggedInUserType
    loggedIn = false
    loading = true
    useCreditCards = true

    public quoteData: Observable<QuoteChanged> = empty()
    public isAgent: boolean
    public validationPassed = false

    showCreditCardValidationMessage = false
    private campaignDiscountText: string
    private loyaltyPointsQuoteText: string

    constructor(
        private resourceService: ResourceService,
        private stepService: StepService,
        private passengerService: PassengerService,
        private environmentService: EnvironmentService,
        private hybridService: HybridService,
        private sbEvent: SbEvent,
        private quoteService: QuoteService,
        private titleService: Title,
        private layoutState: LayoutState,
        private router: Router,
        private trackingService: TrackingService,
        private storage: StorageService
    ) { }

    ngOnInit() {
        this.isAgent = localStorage.getItem('sbw_AgentGenericId') ? true : false;
        this.resourceService.get('PASSENGERS_TITLE', false).subscribe(t => this.titleService.setTitle(t))
        this.reservation = this.stepService.combineToReservation()

        this.resourceService.loadResources(this.reservation.outboundRouteCode, this.resourceService.getLocale(), ['Common', 'Passengers', 'AdditionalInformation', 'Payment', 'Quote', 'Currency'].concat(this.isAgent ? ['Agent', 'MenuAgent'] : []))

        this.passengerForm = new FormGroup({})

        zip(this.passengerService.getPassengersFlow(), this.resourceService.get('PASSENGERS_SELECT_NATIONALITY'), this.resourceService.get('LOYALTY_PRE_CARDNUMBER'), this.resourceService.get('CAMPAIGN_DISCOUNT'), this.resourceService.get('LOYALTYPOINTS_QUOTE'))
            .subscribe(([passengersWire, defaultNationalityText, preCardNumber, campaignDiscountText, loyaltyPointsQuote]) => {

                this.campaignDiscountText = campaignDiscountText
                this.loyaltyPointsQuoteText = loyaltyPointsQuote
                const { titles, countries, phonePrefixes } = passengersWire.passenger

                this.setUserType(passengersWire.agentContact, passengersWire.userProfile)
                this.inputPassengers = {
                    form: this.passengerForm,
                    userProfile: passengersWire.userProfile,
                    titles, // Move this to passenger component, and fetch by itself?
                    countries // Move this to passenger component, and fetch by itself?
                }
                const sessionFlowPassengers = this.reservation.flowPassengers

                if (passengersWire.loyaltyCards.length > 0 && this.loggedInUserType === ELoggedInUserType.ordinaryUser) {
                    this.inputLoyaltyCard = {
                        form: this.passengerForm,
                        preCardNumber: preCardNumber === 'LOYALTY_PRE_CARDNUMBER' ? null : preCardNumber,
                        provider: passengersWire.loyaltyCards[0].provider,
                        userLoyaltyCards: passengersWire.userLoyaltyCards,
                        totalPrice: this.getTotalPriceFromSessionStorage(),
                        hasAccommodation: this.reservation.hasAccommodation !== null && this.reservation.hasAccommodation ? true : false
                    }
                }

                if (this.loggedInUserType === ELoggedInUserType.ordinaryUser) {
                    const { additionalPayments } = sessionFlowPassengers || <any>{}
                    this.inputAdditionalPayments = {
                        form: this.passengerForm,
                        payment: additionalPayments && additionalPayments.payment || 'deposit-payment',
                        depositPayment: passengersWire.deposit,
                        productCode: this.reservation.productCode,
                        campaignCode: additionalPayments && additionalPayments.campaignCode
                    }
                }

                if (passengersWire.creditCards.length > 0 && this.loggedInUserType !== ELoggedInUserType.creditAgent) {
                    this.inputCreditCard = {
                        form: this.passengerForm,
                        creditCards: passengersWire.creditCards,
                        creditCardCode: sessionFlowPassengers && sessionFlowPassengers.creditCardCode
                    }
                }

                this.inputTermsAndCondition = {
                    form: this.passengerForm,
                    termsAndConditionsLink: passengersWire.termsAndConditionsLink
                }

                if (passengersWire.agentContact) {
                    const agentUser = sessionFlowPassengers && sessionFlowPassengers.agentInfo
                    const fromStorage = agentUser && {
                        agentReference: agentUser.agentReference,
                        phonePrefix: agentUser.contactPhoneNumberPrefix,
                        contactPhoneNumber: agentUser.contactPhoneNumber
                    }
                    this.inputAgentDetails = {
                        form: this.passengerForm,
                        agentContact: { ...passengersWire.agentContact, ...fromStorage },
                        phonePrefixes: phonePrefixes,
                        countries: countries
                    }
                }

                if (passengersWire.userProfile) {
                    const user: IFlowPassengersUserWire = sessionFlowPassengers && sessionFlowPassengers.userProfile || passengersWire.userProfile
                    this.inputEditUser = {
                        form: this.passengerForm,
                        countries,
                        titles,
                        phonePrefixes,
                        userDetails: {
                            id: user.id,
                            titleCode: user.titleCode || titles[0].code,
                            firstName: user.firstName,
                            lastName: user.lastName,
                            countryCode: user.countryCode,
                            postalCode: user.postalCode,
                            city: user.city,
                            addressLine1: user.addressLine1,
                            addressLine2: user.addressLine2,
                            email: user.emailAddress,
                            phonePrefix: user.phonePrefix,
                            phone: user.mobileNumber
                        }
                    }
                }

                countries.unshift(new Country('', defaultNationalityText))

                const vehicleAndTrailerType = this.reservation.vehicleAndTrailerTypes && this.reservation.vehicleAndTrailerTypes[0]
                if (passengersWire.vehicle.isVehicleRegistrationMandatory && vehicleAndTrailerType && vehicleAndTrailerType.vehicleId !== '00000000-0000-0000-0000-000000000000') {
                    let vehicles: IInputVehicleDetailsRow[] = []
                    if (sessionFlowPassengers && sessionFlowPassengers.vehicles) {
                        vehicles = sessionFlowPassengers.vehicles.map(m => <IInputVehicleDetailsRow>{ vehicleId: m.vehicleId, vehicleRegistrationNumber: m.vehicleRegistrationNumber, trailerId: m.trailerId, trailerRegistrationNumber: m.trailerRegistrationNumber })
                    } else {
                        for (let count = 1; count <= vehicleAndTrailerType.count; count++) {
                            vehicles.push({ vehicleId: vehicleAndTrailerType.vehicleId, vehicleRegistrationNumber: null, trailerId: vehicleAndTrailerType.trailerId, trailerRegistrationNumber: null })
                        }
                    }
                    this.inputVehicleDetailsRows = <IInputVehicleDetailsRows>{
                        form: this.passengerForm,
                        vehicles
                    }
                    this.selectedVehicleControl = new FormControl({ id: vehicleAndTrailerType.vehicleId, name: vehicleAndTrailerType.vehicleText, registrationNumberIsMandatory: passengersWire.vehicle.isVehicleRegistrationMandatory })
                    this.selectedTrailerControl = new FormControl({ id: vehicleAndTrailerType.trailerId, name: vehicleAndTrailerType.trailerText, registrationNumberIsMandatory: passengersWire.vehicle.isTrailerRegistrationMandatory && vehicleAndTrailerType.trailerId !== '00000000-0000-0000-0000-000000000000' })
                }

                let points = passengersWire.userLoyaltyCards && passengersWire.userLoyaltyCards.length !== 0 && passengersWire.userLoyaltyCards[0].points
                this.quoteData = of(Number.isInteger(points) ? this.updateQuote(PriceSpecificationType.Loyalty, this.loyaltyPointsQuoteText, points, null, 0) : this.updateQuote(null, null, null, null, null))
                this.loading = false
                this.layoutState.setIsContentLoaded(true)

                this.trackingService.trackFlow(TrackingFlowStep.PASSENGERS, 'Passengers', this.reservation, true)
            })
    }

    private getTotalPriceFromSessionStorage(): number {
        return this.quoteService.getQuoteFromSessionStorage().totalPrice;
    }

    editDetailsEventHandler(bum: IEditDetaisChangedEvent) {
        this.editModel = bum
    }

    loyaltyCardPointsToEarn(points) {
        this.quoteData = of(this.updateQuote(PriceSpecificationType.Loyalty, this.loyaltyPointsQuoteText, points, null, 0))
    }

    updateQuote(type: PriceSpecificationType, text: string, amount: number, currenyCode: string, count: number): QuoteChanged {
        const quoteLine = new QuoteLine(text, amount, currenyCode, count)
        const quoteDetails = Number.isInteger(amount) ? new UserQuoteDetails([quoteLine]) : new UserQuoteDetails([])
        const quoteChanged = new QuoteChanged(type, null, null, quoteDetails)
        return quoteChanged
    }

    campaignCodeRedeemed(campaignDiscount) {
        const userQuoteDetails = campaignDiscount ? new UserQuoteDetails([new QuoteLine(this.campaignDiscountText, -Number(campaignDiscount), this.reservation.currencyCode, 1)]) : new UserQuoteDetails([])
        this.quoteData = of(new QuoteChanged(PriceSpecificationType.CampaignDiscounts, null, null, userQuoteDetails))
        this.useCreditCards = this.getTotalPriceFromSessionStorage() > campaignDiscount
        if (!this.useCreditCards) this.passengerForm.removeControl('creditCards')
    }

    updateQuoteWithAdditionalPayment(addDepositToQuote: boolean) {
        const quoteDeposit = addDepositToQuote ? new QuoteDeposit(this.inputAdditionalPayments.depositPayment.amountToPay, this.inputAdditionalPayments.depositPayment.remainingAmount) : null
        this.quoteData = of(new QuoteChanged(PriceSpecificationType.Discounts, null, null, null, quoteDeposit))
    }

    setUserType(agentContact: IFlowPassengersAgentWire, userProfile: IFlowPassengersUserWire) {
        if (agentContact && agentContact.type.toLocaleLowerCase() === 'credit') { this.loggedInUserType = ELoggedInUserType.creditAgent }
        if (agentContact && agentContact.type.toLocaleLowerCase() === 'cash') { this.loggedInUserType = ELoggedInUserType.cashAgent }
        if (userProfile) { this.loggedInUserType = ELoggedInUserType.ordinaryUser }
        if (userProfile == null && agentContact == null) { throw new Error('user must be either agent or ordinary user') }
    }

    specialInstructionsDisabledClicked() {
        if (!this.specialInstructionsSelected) { this.showSpecialInstructions = true }
        this.specialInstructionsSelected = true
    }

    specialInstructionsNoneDisabledClicked() {
        this.specialInstructionsSelected = false
    }

    public continue() {
        this.layoutState.setIsContentLoaded(false)
        const passengers = <IPassenger[]>this.passengerForm.get('passengers').value
        const loyaltyCard = this.inputLoyaltyCard ?
            <ILoyaltyCard>this.passengerForm.get('loyaltyCards').value :
            <ILoyaltyCard>{ cardNumber: null, loyaltyAction: LoyaltyActionEnum.noCard, points: null, provider: null }
        if (loyaltyCard.provider === 2) {
            if (loyaltyCard.cardNumber) {
                loyaltyCard.cardNumber = this.inputLoyaltyCard.preCardNumber + loyaltyCard.cardNumber
            }
        }
        const userDetails = this.passengerForm.get('userDetails') && <IUserDetails>this.passengerForm.get('userDetails').value
        const userProfile = this.loggedInUserType === ELoggedInUserType.ordinaryUser ? <IFlowPassengersUserWire>{
            id: userDetails.id,
            titleCode: userDetails.titleCode,
            firstName: userDetails.firstName,
            lastName: userDetails.lastName,
            countryCode: userDetails.countryCode,
            postalCode: userDetails.postalCode,
            city: userDetails.city,
            addressLine1: userDetails.addressLine1,
            addressLine2: userDetails.addressLine2,
            emailAddress: userDetails.email,
            phonePrefix: userDetails.phonePrefix,
            mobileNumber: userDetails.phone
        } : null

        const agent = (this.loggedInUserType === ELoggedInUserType.creditAgent || this.loggedInUserType === ELoggedInUserType.cashAgent) ? <IAgentInfo>{
            agentReference: this.passengerForm.get('agentDetails.agentReference') && this.passengerForm.get('agentDetails.agentReference').value,
            contactPhoneNumberPrefix: this.passengerForm.get('agentDetails.contactPhonePrefix') && this.passengerForm.get('agentDetails.contactPhonePrefix').value,
            contactPhoneNumber: this.passengerForm.get('agentDetails.contactPhoneNumber') && this.passengerForm.get('agentDetails.contactPhoneNumber').value,
        } : null
        const creditCardCode = this.useCreditCards ? this.passengerForm.get('creditCards.creditCard') && this.passengerForm.get('creditCards.creditCard').value : "CC"
        const selectedCard = creditCardCode && this.inputCreditCard.creditCards.find(c => c.code == creditCardCode)
        const _vehicles = this.passengerForm.get('vehicles')
        let vehicles = []
        if (_vehicles) {
            vehicles = _vehicles.value.map(m => <IVehicleSelection>{ vehicleId: m.vehicleId, vehicleRegistrationNumber: m.vehicleRegistrationNumber, trailerId: m.trailerId, trailerRegistrationNumber: m.trailerRegistrationNumber })
        }
        const additionalPayments = this.passengerForm.get('additionalPayments') && <IAdditionalPayments>this.passengerForm.get('additionalPayments').value
        const depositCode = this.getDepositCode()

        // We mock out payment page if mockBackend flag are enabled
        if (this.environmentService.getSbMockBackend() && this.storage.getItem('e2emock') == 'true') {

            let fakeTrackingData: ITracking = {
                marketingHost: '',
                creditCardFee: 0,
                depositAmount: 0,
                price: 0,
                products: <IWireProduct[]>[],
                features: <IWireFeatureTrack[]>[]
            };

            this.trackingService.saveFlowTrackingData(fakeTrackingData)

            let params = {
                'currency': "£",
                'amountToPay': "299",
                'paymentType': "VISA",
            }
            this.router.navigate(['/ecommerce/fake-payment'], { queryParams: { currency: params.currency, amountToPay: params.amountToPay, paymentType: params.paymentType } })
        } else {
            this.passengerService.postHybrid(creditCardCode, additionalPayments, depositCode, passengers, loyaltyCard, vehicles, userProfile, agent,
                { route: this.reservation.routeCode, card: selectedCard && selectedCard.description }).subscribe(res => {
                    if (res.nextStepUrl) {
                        this.updateStepInLocalStorage(creditCardCode, additionalPayments, passengers, vehicles, userProfile, agent, res.reservationCode)
                        let priceChanged = new PriceChangedPopupModel(this.getTotalPriceFromSessionStorage(), res.quote.totalPrice, this.reservation.currencyCode, res.nextStepUrl, this.reservation.outboundRouteCode)
                        if (priceChanged.priceDiff()) {
                            this.layoutState.setIsContentLoaded(true)
                            this.quoteService.updateBackendQuote(res.quote)
                            this.priceChangedPopupModel = priceChanged
                        } else {
                            this.hybridService.changeWindowLocation(res.nextStepUrl)
                        }
                    } else {
                        this.layoutState.setIsContentLoaded(true)
                        this.errorList = res.errorList.map(e => e.message)
                    }
                    this.trackingService.saveFlowTrackingData(res.trackingData)
                })
        }
    }

    private updateStepInLocalStorage(creditCardCode: string, additionalPayments: IAdditionalPayments, passengers: IPassenger[], vehicles: IVehicleSelection[], userProfile: IFlowPassengersUserWire, agentInfo: IAgentInfo, reservationCode: string) {
        let step: any = {}
        const data = <IFlowReservationPassengers>{
            creditCardCode,
            additionalPayments,
            passengers,
            vehicles,
            userProfile,
            agentInfo,
            reservationCode
        }
        step.flowPassengers = new LocalStorageStepData(SelectionTypeEnum.User, data)
        this.stepService.saveStepData(step, window.location.pathname, false)
    }

    getDepositCode() {
        if (this.passengerForm.get('additionalPayments.payment') == null) { return null }
        if (this.passengerForm.get('additionalPayments.payment').value === 'deposit-payment' && this.inputAdditionalPayments.depositPayment) {
            return this.inputAdditionalPayments.depositPayment.depositCode
        }
        return null;
    }

    public navigateBack() {
        this.sbEvent.historyGoBack.next()
    }

}
enum ELoggedInUserType {
    creditAgent,
    cashAgent,
    ordinaryUser
}
